import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const MapaUbicaciones = ({ empresa }) => {
  return (
   <ContenedorInfoUbicacion>
      {empresa && (
          <img src={empresa.mapa_footer} alt="¿Donde está LOi?" />
      )}
      <p>
        {empresa &&
          empresa.sucursales &&
          empresa.sucursales.length > 0 &&
          empresa.sucursales.map((sucursal, index) => (
            <span key={index}>
              <b>{sucursal.nombre}</b>{` - ${sucursal.direccion} ${sucursal.numero_puerta}`}
              <br />
            </span>
          ))}
      </p>
    </ContenedorInfoUbicacion>
  );
};
const ContenedorInfoUbicacion = styled.article`
  text-align: center;
  float: left;
  >img{
    -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  width: 100%;
  }
  >p{
      text-align:left;
  }
  @media only screen and (max-width: 720px) {
    display: none;
  }
`;

MapaUbicaciones.propTypes = {
  empresa: PropTypes.object,
};
export default MapaUbicaciones;
